import { getHoleStrokes } from '@polf/shared/scoring'

/**
 * The strokes an entry receives on one hole.
 *
 * The server already puts this on every score row, correctly for every format
 * — verified across scramble, foursome, best ball and singles. The client used
 * to recompute it from the entry's round allowance to work around a scramble
 * row returning 0, which was fixed when team instances started carrying their
 * event; recomputing outlived its reason.
 *
 * It cannot survive a split round in any case: that allocation is a third of
 * the allowance spread over a six-hole block and ranked WITHIN that block, so
 * it is not derivable from a round figure and an 18-hole stroke index. A
 * player entry has a perfectly good round allowance there and deriving from it
 * silently produced the wrong holes.
 *
 * A match is the one caller that still derives, because the strokes it reports
 * are the pairing's differential — a number the server does not put on the
 * row, and deliberately not the player's own allowance (POL-79).
 */
export const holeStrokesFor = (
  matchStrokes: number | null | undefined,
  row: { strokes?: number | null } | null | undefined,
  holeIndex: number
): number => {
  if (matchStrokes != null) {
    return matchStrokes > 0 ? getHoleStrokes(matchStrokes, holeIndex) : 0
  }
  return row?.strokes ?? 0
}
